import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Kliknij przycisk poniżej, aby przejrzeć i potwierdzić dane płatności.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Współpracujemy ze Stripe w zakresie obsługi płatności. Stripe to najbezpieczniejsza platforma płatnicza używana przez największe firmy na świecie.',
      form: {
        terms_acceptance: {
          label:
            'Kontynuując, akceptujesz naszą <FoodAmigosTerms>Umowę o świadczenie usług</FoodAmigosTerms> oraz <StripeTerms>Umowę konta połączonego Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe nadal potrzebuje poniższych danych lub nie udało się ich zweryfikować:',
        errors: 'Błędy',
        awaiting_verification: 'Twoje konto Stripe jest weryfikowane',
        awaiting_verification_description:
          'Czekamy, aż Stripe zakończy weryfikację Twojej firmy. W międzyczasie możesz przejrzeć swój profil.',
        details_hint:
          'Stripe weryfikuje imiona i nazwiska, adresy oraz numery telefonów w oficjalnych rejestrach. Jeśli któreś z nich jest błędne, należy je poprawić w Moje dane → Dane osobowe, a Stripe sprawdzi je ponownie. Pozostałe informacje, o które prosi Stripe, można uzupełnić w profilu Stripe.',
        requirements_hint:
          'Niektóre z nich to dokumenty, np. Twój dowód tożsamości: prześlij je w poprzednim kroku, {{step}}, a następnie wróć tutaj.',
        requirements_hint_profile:
          'Niektóre z nich to dokumenty, np. Twój dowód tożsamości: prześlij je w swoim profilu Stripe.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Właściciel',
          representative: 'Przedstawiciel',
          business: 'Firma',
        },
        details: {
          first_name: 'Imię',
          last_name: 'Nazwisko',
          email: 'E-mail',
          phone: 'Numer telefonu',
          dob: 'Data urodzenia',
          id_number: 'Numer dokumentu tożsamości',
          nationality: 'Narodowość',
          address: 'Ulica i numer domu',
          city: 'Miasto',
          postal_code: 'Kod pocztowy',
          state: 'Województwo',
          country: 'Kraj',
          id_document: 'Dokument tożsamości',
          proof_of_address: 'Potwierdzenie adresu',
          job_title: 'Stanowisko',
          business_name: 'Pełna nazwa firmy',
          tax_id: 'Numer podatkowy',
          vat_id: 'Numer VAT',
          registration_number: 'Numer rejestrowy',
          website: 'Strona internetowa',
          industry: 'Branża',
          product_description: 'Opis oferowanych produktów',
          support_phone: 'Numer telefonu obsługi klienta',
          owners: 'Potwierdzenie właścicieli',
          directors: 'Potwierdzenie dyrektorów',
          executives: 'Potwierdzenie kadry zarządzającej',
          registration_document: 'Dokument rejestracji firmy',
          bank_account: 'Konto bankowe do wypłat',
          business_type: 'Rodzaj działalności',
          terms: 'Akceptacja regulaminu Stripe',
          bank_account_proof: 'Potwierdzenie własności konta bankowego',
          tax_id_document: 'Dokument numeru podatkowego',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Współpracujemy z Adyen w zakresie obsługi płatności. Adyen to jedna z najbezpieczniejszych platform płatniczych używanych przez największe firmy na świecie.',
    },
  },
  labels: {
    verified: 'Twoje konto {{paymentGateway}} jest zweryfikowane',
    verified_description:
      'Weryfikacja dla {{paymentGateway}} została zakończona. W razie potrzeby możesz zarządzać swoim profilem.',
  },
  buttons: {
    proceed: 'Potwierdź moje dane płatności',
    copy_link: 'Kopiuj link',
    back: 'Wstecz',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak, skontaktuj się z pomocą techniczną',
  },
};
